module.exports = __webpack_public_path__ + "static/media/gif2.827a23c4.gif";